import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  tenantPreference: generateApiPath({ prefix: AuthLevel.AUTH, name: 'tenant-preference' }),
}

export { paths }
